import React from "react";
import { Link } from "react-router-dom";
import "./header.css";

const BOOKING_URL =
  "https://www.massagebook.com/therapists/shirley-massage-therapy";

const Header = () => {
  return (
    <main className="Header">
      <div className="message-container" aria-label="Current promotions">
        <span>Seasonal promotions available on Facebook and Google</span>
        <span className="message-dot">•</span>
        <span>Seniors 65+ and college students receive 10% off</span>
      </div>

      <section className="hero">
        <div className="hero-content">
          <p className="eyebrow">
            Personalized massage therapy in Plano, Texas
          </p>
          <h1>Feel better in your body.</h1>
          <p className="hero-intro">
            Thoughtful, therapeutic bodywork designed to ease pain, restore
            movement, and create space for relaxation.
          </p>
          <div className="hero-actions">
            <a
              className="primary-button"
              href={BOOKING_URL}
              target="_blank"
              rel="noreferrer"
            >
              Book an appointment
            </a>
            <Link className="secondary-button" to="/services">
              Explore treatments
            </Link>
          </div>
          <div className="hero-details">
            <span>Licensed Massage Therapist</span>
            <span>LMT #139596</span>
            <a href="tel:+14699889039">469-988-9039</a>
          </div>
        </div>
        <div className="hero-image-wrap">
          <img
            src="/slide5.png"
            alt="Private massage treatment room at Shirley Massage Therapy"
          />
          <div className="hero-image-card">
            <strong>Shirley Tan, LMT</strong>
            <span>Care tailored to how you feel today</span>
          </div>
        </div>
      </section>

      <section className="home-services" aria-labelledby="care-heading">
        <div className="section-heading">
          <p className="eyebrow">Focused care</p>
          <h2 id="care-heading">A better path to feeling like yourself</h2>
          <p>
            Each session is adapted to your comfort, goals, and unique needs.
          </p>
        </div>
        <div className="home-service-grid">
          <article>
            <span>01</span>
            <h3>Therapeutic Massage</h3>
            <p>
              Flowing Swedish techniques paired with focused work to release
              tension and encourage relaxation.
            </p>
          </article>
          <article>
            <span>02</span>
            <h3>Lymphatic Drainage</h3>
            <p>
              Gentle, precise movements that support fluid circulation and the
              body’s natural recovery process.
            </p>
          </article>
          <article>
            <span>03</span>
            <h3>Neuromuscular Therapy</h3>
            <p>
              Targeted care using myofascial release, trigger point therapy,
              cupping, and stretching.
            </p>
          </article>
        </div>
        <Link className="text-link" to="/services">
          View services and pricing <span>→</span>
        </Link>
      </section>

      <section className="Header-about">
        <div className="about-image">
          <img src="/slide5.png" alt="Private massage treatment room" />
        </div>
        <div className="about-copy">
          <p className="eyebrow">A personal approach</p>
          <h2>Therapeutic care, grounded in listening.</h2>
          <p>
            Shirley Massage Therapy is a private practice in Plano specializing
            in therapeutic Swedish massage, lymphatic drainage, muscle energy
            technique, orthopedic cupping, and stretching.
          </p>
          <p>
            We take time to understand what your body needs, so every visit
            feels personal, comfortable, and purposeful.
          </p>
          <Link className="text-link" to="/about">
            Meet your therapist <span>→</span>
          </Link>
        </div>
      </section>

      <section className="Header-reviews">
        <div className="section-heading">
          <p className="eyebrow">Client experiences</p>
          <h2>What our clients say</h2>
        </div>
        <div className="reviews-frame">
          <iframe
            title="Shirley Massage Therapy client reviews"
            src="https://www.massagebook.com/therapists/shirley-massage-therapy/widget/reviews"
          />
        </div>
      </section>

      <section className="home-cta">
        <div>
          <p className="eyebrow">Your next step</p>
          <h2>Give your body the care it deserves.</h2>
        </div>
        <a
          className="light-button"
          href={BOOKING_URL}
          target="_blank"
          rel="noreferrer"
        >
          Schedule your session
        </a>
      </section>
    </main>
  );
};

export default Header;
